//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState, useCallback, useRef } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import * as moment from 'moment';

// material-ui
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Container } from '@material-ui/core';
import Button from '@material-ui/core/Button';

// custom pages
import Sidebar from 'components/SideBar/SideBar';
import DashboardHeader from 'components/Header/DashboardHeader';
import DashboardRoutes from 'routes/DashboardRoutes/dashboardRoutes';
import SideBarRoutes from 'routes/SideBarRoutes/sideBarRoutes';
import Context from 'context/context';
import FilterRoutes from 'routes/FilterRoutes';
import DashboardFooter from 'components/Footer/DashboardFooter';
import { dashboardStyles } from './style';
import HSBanner from 'assets/img/Banner-Image.png';
import HSCABanner from "assets/img/HSBanner.jpg";
import HSBannerFR from 'assets/img/HS_Banner_Fr.jpg';
//import Startupbanner from 'assets/img/startupbanner.jpg';
import SessionMaintain from 'apis/sessionMaintain/SessionMaintain';
import StaticAPI from 'apis/static/static';
import language from 'apis/language/language';

import { useTranslation } from 'react-i18next';
//material ui
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { imageHandler } from 'helpers/imageHandler';

// import { Carousel } from 'antd';
import Carousel from 'components/Carousel/Carousel';
import banner from 'apis/banner/banner';
import WarningIcon from '@material-ui/icons/Warning';
import StatementPDF from 'views/Dashboard/Dashboard/StatementPDF';


function Dashboard() {
  const { state, dispatch } = useContext(Context);

  const { t, i18n } = useTranslation();
  const isCA = state?.userInfo?.loyalty_organization_name !== 'Henry Schein Dental';
console.log("Language:", i18n.language);
console.log("Org:", state?.userInfo?.loyalty_organization_name,isCA);
  const classes = dashboardStyles();
  const history = useHistory();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [logoutdialogOpen, setLogOutDialogOpen] = useState(false);
  const [faqDialogOpen, setFaqDialogOpen] = useState(false);
  const { verifyToken, logout, extendSessionTime } = SessionMaintain();
  const { getBannerText } = StaticAPI();
  const { selectedLanguage } = language()
  const { getschedule } = banner(); // Make sure update method exists in your API
  const [bannerList, setBannerList] = useState({
  thriveBanners: [],
  signatureBanners: [],
  signatureBannersMonthly: [],
  signatureBannersYearly: [],
  signatureBannersTrial: [],
  signatureBannersAll: [],

  // ADD THIS
  startupBanners: [],

  TierBannersCore: [],
  TierBannersElite: [],
  TierBannersSelect: [],
  allBanners: [],
  targetBanners: [],
  bannerStyle: 'fade',
  bannerInterval: 5
})


  const [states, setstates] = useState({
    CustomDashboard: [],
    sidebar: [],
    banner: false,
    bannerText: '',
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (state?.userInfo && Object.keys(state.userInfo)?.length > 0) {
      handleGetBannerText();
      fetchImages();
    }
  }, [state.userInfo]);

  const handleGetBannerText = async () => {
    try {
      let data = await getBannerText();
      if (data && data?.type === 'SUCCESS') {
        let currentDate = moment().format();
        if (
          moment(currentDate).isSameOrAfter(data?.start_date) &&
          moment(currentDate).isSameOrBefore(data?.end_date)
        ) {
          setStates({ banner: true, bannerText: data?.msg });
        }
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const MINUTE_MS = 60000;

  useEffect(() => {
    if (state?.userInfo?.role_id == 10 || state?.userInfo?.role_id == 3 || state?.userInfo?.role_id == 12) {
      const interval = setInterval(() => {
        handleVerifyToken();
      }, MINUTE_MS);
      return () => clearInterval(interval);
    }
  }, []);

  async function handleVerifyToken() {
    let expiresIn = moment(decodeURIComponent(getCookie('eX')));
    let diff = expiresIn.diff(moment(), 'minutes');
    if (diff == 0) {
      await handleLogout();
    }
    if (diff <= 5) {
      setDialogOpen(true);
    }
  }

  function getCookie(cookieName) {
    let cookie = {};
    document.cookie.split(';').forEach(function (el) {
      let [key, value] = el.split('=');
      cookie[key.trim()] = value;
    });
    return cookie[cookieName];
  }

  async function handleLogout() {
    try {
      dispatch({ type: 'SET_LOADING', payload: true });
      const data = await logout();
      if (data.message == 'success') {
        dispatch({ type: 'SET_LOGOUT' });
        history.push('/login');
      }
      dispatch({ type: 'SET_LOADING', payload: false });
    } catch (error) {
      console.log({ error });
    }
  }

  async function handleExtendSession() {
    try {
      let data = await extendSessionTime();
      if (data.message == 'success') {
        setDialogOpen(false);
      }
    } catch (error) {
      console.log({ error });
    }
  }

  useEffect(() => {
    if (state && state.userInfo && Object.keys(state.userInfo).length > 0) {
      handleSetDashboard();
      fetchImages();
      return;
    }
  }, [state.userInfo]);

  // mounting components
  async function handleSetDashboard() {
    try {
      if (
        state &&
        state.userInfo.allowedRoutes &&
        Object.keys(state.userInfo.allowedRoutes).length > 0
      ) {
        const customDashboard = DashboardRoutes.map((route, i) => {
          if (route.redirect) {
            return <Redirect key={`DashBoardRoutes-${i}`} to={route.to} />;
          }
          return (
            <Route
              key={i}
              path={route.path}
              component={() => <route.component key={i} />}
            />
          );
        });
        const filteredDashboardRoutes = FilterRoutes(
          customDashboard,
          state.userInfo.allowedRoutes
        );
        const filteredSideBarRoutes = FilterRoutes(
          SideBarRoutes,
          state.userInfo.allowedRoutes
        );
        if (filteredDashboardRoutes && filteredSideBarRoutes) {
          setStates({
            CustomDashboard: filteredDashboardRoutes,
            sidebar: filteredSideBarRoutes,
          });
        }
      }
    } catch (e) {
      console.log({ e });
    }
  }

  const handleLanguage = async (data) => {
    try {
      let input = {
        language_code: data
      }

      let update = await selectedLanguage(input)

      if (update?.status == 200) {
        i18n.changeLanguage(data);
      } else {
        i18n.changeLanguage(data);
      }
    } catch (err) {
      throw err
    }
  };

  const fetchImages = async () => {
    try {
      const response = await getschedule();
      setBannerList({
        ...bannerList,
        thriveBanners: response?.data?.filter(b => (b.is_active == true && (b.type == "THRIVE" || b.type == "BOTH" || b.type == "ALL"))),
        signatureBanners: response?.data?.filter(b => (b.is_active == true && b.type == "SIGNATURE" || b.type == "BOTH" || b.type == "ALL" || b.type == "SIGNATUREALL")),
        signatureBannersMonthly: response?.data?.filter(b => (b.is_active == true && b.type == "MONTHLY" || b.type == "SIGNATUREBOTH" || b.type == "SIGNATUREALL")),
        signatureBannersYearly: response?.data?.filter(b => (b.is_active == true && b.type == "YEARLY" || b.type == "SIGNATUREBOTH" || b.type == "SIGNATUREALL")),
        signatureBannersTrial: response?.data?.filter(b => (b.is_active == true && b.type == "SIGNATURETRIAL" || b.type == "SIGNATUREALL")),
        signatureBannersAll: response?.data?.filter(b => (b.is_active == true &&  b.type == "SIGNATUREALL")),
        TierBannersCore: response?.data?.filter(b => (b.is_active == true && b.type == "Core")),
        TierBannersElite: response?.data?.filter(b => (b.is_active == true && b.type == "Elite")),
        TierBannersSelect: response?.data?.filter(b => (b.is_active == true && b.type == "Select")),
        startupBanners: response?.data?.filter(b => (b.is_active == true && (b.type == "STARTUP" || b.type == "ALL"))),
        allTypeBanners: response?.data?.filter(b => (b.is_active == true && (b.type == "ALL" || b.type == "BOTH"))),
        allBanners:response?.data,
        targetBanners:response?.targetBanners,
        bannerInterval: response?.bannerInterval,
        bannerStyle: response?.bannerStyle
      });
    } catch (error) {
      console.error("Failed to fetch banner images:", error);
    }
  };


  const org = state?.userInfo?.loyalty_organization_name;
  let runningBanners;

  // Example inputs:
// banners = [{ id: 1, type: 'loyalty' }, { id: 2, type: 'billto' }, ...]
// targets = [{ target_banner_id: 1, target_account: '123', target_type: 'loyalty' }, ...]
// req.aca = { loyaltyid: '123', customerbillto: '456', customershipto: '789' }

const filteredBanners = bannerList?.allBanners?.filter(banner => {
  // Find matching target(s) by banner id
  const matchingTargets = bannerList?.targetBanners?.filter(target => target.target_banner_id === banner.id);

  // If no matching targets, skip this banner
  if (matchingTargets?.length === 0) return false;

  // Check if any of the matching targets pass the type/account checks
  return matchingTargets?.some(target => {
    if (banner.type === 'Loyalty_id_based' && target.target_type === 'Loyalty_id_based') {
      return state?.ALA?.loyalty_id === target.target_account;
    } else if (banner.type === 'Billto_based' && target.target_type === 'Billto_based') {
      return state?.ALA?.customer_billto_account_number === target.target_account;
    } else if (banner.type === 'Shipto_based' && target.target_type === 'Shipto_based') {
      return state.ACA?.customer_account_number === target.target_account;
    }
    return false;
  });
});

if(filteredBanners&& filteredBanners?.length>0){
  runningBanners = filteredBanners;

}else if (state?.ACA?.signature_flag) {
    if (state?.ACA?.privilege_code?.toLowerCase() === 'st0' && bannerList?.signatureBannersMonthly?.length > 0) {
      runningBanners = bannerList.signatureBannersMonthly;
    } else if (state?.ACA?.privilege_code?.toLowerCase() === 'st1' && bannerList?.signatureBannersYearly?.length > 0) {
      runningBanners = bannerList.signatureBannersYearly;
    }  else if (state?.ACA?.privilege_code?.toLowerCase() === 'st2' && bannerList?.signatureBannersTrial?.length > 0) {
      runningBanners = bannerList.signatureBannersTrial;
    }
    
    else {
      runningBanners = bannerList.signatureBanners;
    }
  } 
  else if (state?.ACA?.privilege_code?.toLowerCase() === 'st3' && state?.ACA?.startup_flag) {
    if (bannerList.startupBanners?.length > 0) {
      runningBanners = bannerList.startupBanners;
    } else if (bannerList.allTypeBanners?.length > 0) {
      runningBanners = bannerList.allTypeBanners;
    } else {
      runningBanners = bannerList.thriveBanners;
    }
  }
  else if (!state?.ACA?.signature_flag && !state?.ACA?.startup_flag) {
    const tier = state?.ALA?.["Loyalty_Account.tier"]?.toLowerCase();
  
    if (tier === "core") {
      runningBanners =
        bannerList.TierBannersCore?.length > 0
          ? bannerList.TierBannersCore
          : bannerList.thriveBanners;
  
    } else if (tier === "elite") {
      runningBanners =
        bannerList.TierBannersElite?.length > 0
          ? bannerList.TierBannersElite
          : bannerList.thriveBanners;
  
    } else if (tier === "select") {
      runningBanners =
        bannerList.TierBannersSelect?.length > 0
          ? bannerList.TierBannersSelect
          : bannerList.thriveBanners;
  
    } else {
      runningBanners = bannerList.thriveBanners;
    }
  }
  else {
    runningBanners = bannerList.thriveBanners;
  }

  // ── Dynamic CA language-based banner filtering ──────────────────────────
  
  const LANGUAGE_MAP = {
    en: 'ENGLISH',
    fr: 'FRENCH',
  };
  
  let finalBanners = runningBanners;
  
  if (isCA) {
    const uiLang = LANGUAGE_MAP[i18n.language] || 'ENGLISH';
    const source = runningBanners || [];
  
    const matchByLanguage = (langCode) =>
      source.filter((b) => {
        const bannerLang = b?.language?.toUpperCase();
        return bannerLang === 'BOTH' || bannerLang === langCode;
      });
  
    const matched = matchByLanguage(uiLang);
  
    finalBanners = matched.length > 0 ? matched : matchByLanguage('ENGLISH');
  }
  // ─────────────────────────────────────────────────────────────────────

  // e.g. "June 28, 2025"
  const raw = state?.userInfo?.riskDateResult; // e.g. "June 28, 2025"
  const riskdate =  moment(raw).format("MMMM D, YYYY");
  // const dialogRef = useRef(null);
  // useEffect(() => {
  //   if (dialogRef.current) {
  //     dialogRef.current.showModal(); 
  //   }
  // }, []);

 

  //let startupbanner = (state?.ACA?.privilege_code?.toLowerCase() === 'st3' && state?.ACA?.startup_flag )


 
  

 return (
  <React.Fragment>
    <Container>
      <DashboardHeader />

      {states?.banner && (
        <div className={classes.bannerText}>
          {states?.bannerText}
        </div>
      )}

      <Carousel
        autoPlay={true}
        displayArrow={false}
        interval={bannerList?.bannerInterval * 1000}
        animationType={bannerList?.bannerStyle}
      >
        {finalBanners &&
          finalBanners.length > 0 &&
          finalBanners.map((i, index) => (
            <div
              key={i?.id || index}
              className={classes.HSBanner}
              style={
                state?.pathName?.length > 0
                  ? { margin: '5px 0 0 0', cursor: 'pointer' }
                  : { margin: '5px 0 10px 0', cursor: 'pointer' }
              }
              onClick={() => {
                if (i?.cover_url) {
                  window.open(i.cover_url, '_blank');
                }
              }}
            >
              <img
                src={i?.url}
                alt=""
                width="100%"
              />
            </div>
          ))}
      </Carousel>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Breadcrumbs aria-label='breadcrumb' separator='›'>
            {state.pathName?.map((link, i) => (
              <span
                key={i}
                color='inherit'
                href=''
                style={{ fontSize: '12px' }}
              >
                {t(link).toUpperCase()}
              </span>
            ))}
          </Breadcrumbs>
          <div>
            {org !== "Henry Schein Dental" &&
              state.language?.map((data, i) => {
                return (
                  <>
                    <span
                      key={i}
                      className={classes.language}
                      onClick={() => handleLanguage(data.language_code)}
                      style={
                        data.language_code === i18n.language
                          ? { borderRadius: '10px', color: 'blue' }
                          : { borderRadius: '10px', color: 'black' }
                      }
                    >
                      {t(data.language)}
                    </span>
                    <span>
                      {state.language.length - 1 !== i && <>{'|'}</>}
                    </span>
                  </>
                );
              })}
          </div>
          {(state?.userInfo?.isCdrAdmin) && (
            <div>
              <button className={classes.logoutBtn} onClick={() => { if (org != "Henry Schein Dental") { setLogOutDialogOpen(true) } else { handleLogout() } }}>
                {t('logout')}
              </button>
            </div>
          )}
        </div>

        {state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental' && state?.userInfo?.dormantredeemstatus ? (
          <div style={{ backgroundColor: '#FFF5CC', display: 'flex', height: '41px', borderRadius: '10px' }}>
            {/* <img src={imageHandler?.[org]?.[i18n.language]?.warning} style={{margin: '9px',marginLeft:"37px"}} /> */}



            <span style={{ margin: '11px', marginLeft: "30px" }}> ⚠️ You haven't redeemed in 23 months. To avoid losing your <b>Points Balance and member benefits (including service discounts),</b> redeem by <b>{riskdate}</b></span>

          </div>
        ) : null}

     

        <div className={classes.root} style={{ background: '#fff' }}>
          <div
            className={state.sidebar ? classes.sidebarOne : classes.sidebarTwo}
          >
            <Sidebar routes={states.sidebar} />
          </div>


          {/* because of overflow problem i was created two classes here */}
          <main
            style={{ background: '#fff' }}
            className={
              window.location.pathname === 'dashboard/report'
                ? classes.dashboard
                : classes.dashboardOne
            }
          >
            {/* <div style={{marginBottom: 10}}><img src={HSBanner} alt="" width="100%" height="200" /> </div> */}
            <Switch>{states.CustomDashboard}</Switch>
          </main>
        </div>
      </Container>


      <DashboardFooter />
      <Dialog
        aria-labelledby='simple-dialog-title'
        open={dialogOpen}
        style={{ fontFamily: 'Segoe-ui' }}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>
            {' '}
            {t('You’ve been logged out.')}
          </div>
          <span className={classes.subParentText}>
            {t(
              'You been idle for some time, to keep the session active click continue or click cancel to logout from the session.'
            )}
          </span>
          <br />
          <br />
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <Button
                className={classes.noBtn}
                onClick={() => {
                  handleLogout();
                }}
              >
                {t('Cancel')}
              </Button>
            </Grid>
            <Grid item xs={6} className={classes.proceedBtnGrid}>
              <Button
                className={classes.proceedBtn}
                onClick={() => {
                  handleExtendSession();
                }}
              >
                {'Continue'}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
      <Dialog
        aria-labelledby='simple-dialog-title'
        open={logoutdialogOpen}
        style={{ fontFamily: 'Segoe-ui' }}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>
            {' '}
            {t('Logout')}
          </div>
          <span className={classes.subParentText}>
            {t(
              'Are you sure you want to Logout?'
            )}
          </span>
          <br />
          <br />
          <Grid container spacing={3}>
            <Grid item xs={6} className={classes.proceedBtnGrid}>
              <Button
                className={classes.noBtn}

                onClick={() => {
                  setLogOutDialogOpen(false)
                }}
              >
                {t('Cancel')}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                className={classes.proceedBtn}
                onClick={() => {
                  handleLogout();
                }}
              >
                {t('Confirm')}
              </Button>
            </Grid>

          </Grid>
        </div>
      </Dialog>


    </React.Fragment>
  );
}

export default Dashboard;
